import { makeLoadable } from '../../LoadableWrapper';
const AsyncContactsPriceBreakdownModal = makeLoadable({
  loader: () => import( /* webpackChunkName: "contact-price-breakdown-modal" */'./ContactsPriceBreakdownModal')
});
export default AsyncContactsPriceBreakdownModal;